import UserRegisterContainer from './UserRegisterContainer';
export default UserRegisterContainer;
